import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FreeCancellationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"free_cancellation"}/>
}
